module.exports = __webpack_public_path__ + "static/assets/af79a0af48429cc0b5896796b2927a85.svg";